import React from 'react';
import {Formik, Form} from 'formik';
import formFieldMap from './FormFieldMaps';
import Wrapper from 'Components/Wrapper';
import {Card, Flex, Row, Typography} from 'antd';

const FormikForm = (props) => {
  let customProps = props;
  return (
    <Formik
      initialValues={customProps.initialValues}
      validationSchema={customProps.validationSchema}
      onSubmit={(values, actions) => {
        customProps.onSubmit(values).then(() => {
          actions.setSubmitting(false);
        });
      }}
      enableReinitialize={true}>
      {(props) => (
        <Form>
          <Wrapper>
            <Card style={{marginTop: 16, marginBottom: 16}}>
              {customProps.topButtonStack ? (
                <Row gutter={16}>
                  {customProps.topButtonStack.fields.map((field) => {
                    return formFieldMap[field.fieldType](field, props, customProps);
                  })}
                </Row>
              ) : null}
              {customProps.section1 ? (
                <Flex vertical gap={16} style={{padding: 32}}>
                  <Typography.Text strong>{customProps.section1.title}</Typography.Text>
                  <Row gutter={16}>
                    {customProps.section1.fields.map((field) => {
                      return formFieldMap[field.fieldType](field, props, customProps);
                    })}
                  </Row>
                </Flex>
              ) : null}
              {customProps.section2 ? (
                <Flex vertical gap={16} style={{padding: 32}}>
                  <Typography.Text strong>{customProps.section2.title}</Typography.Text>
                  <Row gutter={16}>
                    {customProps.section2.fields.map((field) => {
                      return formFieldMap[field.fieldType](field, props, customProps);
                    })}
                  </Row>
                </Flex>
              ) : null}
              {/* need to copy at top */}
              {customProps.buttonStack ? (
                <Row gutter={16} justify="end">
                  {customProps.buttonStack.fields.map((field) => {
                    return formFieldMap[field.fieldType](field, props, customProps);
                  })}
                </Row>
              ) : null}
            </Card>
          </Wrapper>
        </Form>
      )}
    </Formik>
  );
};

export default FormikForm;
